module.exports = __webpack_public_path__ + "img/incident_movement_end.9f2a41ca.svg";